// extracted by mini-css-extract-plugin
module.exports = {"container":"SafePassword_container_3xrWc","goBack":"SafePassword_goBack_2CFdC"};